import { DragDropContext } from "react-beautiful-dnd";
import { useDispatch } from "react-redux";
import {
  DRAG_AND_DROP,
  SET_CURRENTLY_DRAGGING,
} from "../../Constants/reducerEvents";

export default function DDContext({ ...props }) {
  const dispatch = useDispatch();
  const handleOnDragEnd = (result) => {
    dispatch({ type: SET_CURRENTLY_DRAGGING, payload: false });
    console.log("done", result);
    if (result.destination !== null) {
      console.log("dispatching");
      dispatch({
        type: DRAG_AND_DROP,
        payload: {
          source: { id: result.source.droppableId, index: result.source.index },
          destination: {
            id: result.destination.droppableId,
            index: result.destination.index,
          },
        },
      });
    }
  };
  const handleOnDragStart = () => {
    console.log("Start");
    dispatch({ type: SET_CURRENTLY_DRAGGING, payload: true });
  };
  return (
    <DragDropContext
      onDragEnd={handleOnDragEnd}
      onDragStart={handleOnDragStart}
    >
      {props.children}
    </DragDropContext>
  );
}
